// Shared client-side helpers, constants and localStorage journey store.

export const CATEGORIES = ["All", "Citizenship", "Golden Visa", "Caribbean", "Tax Haven", "Fast Track", "Family-First"];

export const CLASSIFICATION_META = {
  required: { label: "Required", color: "#E2C275", bg: "rgba(226,194,117,0.14)", border: "rgba(226,194,117,0.4)" },
  conditional: { label: "Conditional", color: "#38BDF8", bg: "rgba(56,189,248,0.12)", border: "rgba(56,189,248,0.35)" },
  optional: { label: "Optional", color: "#94A3B8", bg: "rgba(148,163,184,0.12)", border: "rgba(148,163,184,0.3)" },
};

export const STATUS_META = {
  not_started: { label: "Not Started", color: "#64748B" },
  in_progress: { label: "In Progress", color: "#38BDF8" },
  action_required: { label: "Action Required", color: "#F59E0B" },
  completed: { label: "Completed", color: "#10B981" },
  not_applicable: { label: "Not Applicable", color: "#475569" },
};

const KEY = "gmjp_state_v1";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

function write(state) {
  localStorage.setItem(KEY, JSON.stringify(state));
  window.dispatchEvent(new Event("gmjp_state"));
}

export function getState() {
  const s = read();
  return {
    journeys: s.journeys || {},
    saved: s.saved || [],
    compare: s.compare || [],
    enquiries: s.enquiries || [],
  };
}

export function addEnquiry(code) {
  const s = read();
  const set = new Set(s.enquiries || []);
  set.add(code);
  write({ ...s, enquiries: [...set] });
}

export function toggleSaved(code) {
  const s = getState();
  const set = new Set(s.saved);
  set.has(code) ? set.delete(code) : set.add(code);
  write({ ...read(), saved: [...set] });
}

export function toggleCompare(code) {
  const s = getState();
  let list = [...s.compare];
  if (list.includes(code)) list = list.filter((c) => c !== code);
  else {
    if (list.length >= 3) list.shift();
    list.push(code);
  }
  write({ ...read(), compare: list });
}

export function startJourney(country) {
  const s = read();
  const journeys = s.journeys || {};
  if (!journeys[country.code]) {
    journeys[country.code] = {
      code: country.code,
      objective: country.objective,
      answers: { property: false, business: false, family: true },
      selected: {},
      startedAt: new Date().toISOString(),
    };
  }
  write({ ...s, journeys });
}

export function updateJourney(code, patch) {
  const s = read();
  const journeys = s.journeys || {};
  journeys[code] = { ...journeys[code], ...patch };
  write({ ...s, journeys });
}

export function setAnswer(code, key, value) {
  const s = read();
  const journeys = s.journeys || {};
  const j = journeys[code];
  if (!j) return;
  j.answers = { ...j.answers, [key]: value };
  journeys[code] = j;
  write({ ...s, journeys });
}

export function setNodeSelected(code, nodeId, value) {
  const s = read();
  const journeys = s.journeys || {};
  const j = journeys[code];
  if (!j) return;
  j.selected = { ...(j.selected || {}), [nodeId]: value };
  journeys[code] = j;
  write({ ...s, journeys });
}

// Which workflow nodes are active given the user's yes/no answers.
export function visibleNodes(workflow, answers) {
  return (workflow || []).filter((n) => {
    if (n.classification !== "conditional") return true;
    return !!answers?.[n.branch];
  });
}

export function journeyProgress(country, journey) {
  if (!country || !journey) return 0;
  const nodes = visibleNodes(country.workflow, journey.answers);
  if (!nodes.length) return 0;
  const done = nodes.filter((n) => journey.selected?.[n.id]).length;
  return Math.round((done / nodes.length) * 100);
}
